import {
  atom
} from 'recoil';

export const appplicationActiveStep = atom({
  key: 'appplicationActiveStep',
  default: -1
});